
<template>
  <v-container v-if="permitted == false && permitted != null" class="pt-0" fluid>
    <v-dialog v-model="permitted_dialog" max-width="400px">
      <v-card>
        <v-card-text>
          <div class="text-center">
            <div class="title font-weight-light pt-2"><v-icon class="mr-1">mdi-shield-lock-outline</v-icon>Security Error</div>
            <p>{{message}}</p>
            <v-progress-circular
              :size="70"
              :width="2"
              :value="100"
              color="error"
              class="mb-4 mr-4"
            >
              <v-icon color="red" x-large>mdi-exclamation-thick</v-icon>
            </v-progress-circular>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
  <v-container v-else v-show="permitted != null" class="pt-0" fluid>
    <v-snackbar
      :value="showMessage()"
      multi-line
      color="#686868"
      top
    >
      {{message}}
    </v-snackbar>
    <v-card flat >
    <v-toolbar dense flat color="#2A353D">
      <v-toolbar-title class="white--text subtitle-1 font-weight-normal">{{heading}}</v-toolbar-title>
      <v-spacer/>
      <v-btn fab x-small outlined color="#81DBF6" class="mr-1" v-if="edit == true || create == true" @click="view = false; closeCreate(); closeEdit()"><v-icon>mdi-chevron-left</v-icon></v-btn>
      <v-btn fab x-small outlined color="#81DBF6" @click="$router.push('/Home')"><v-icon>mdi-close</v-icon></v-btn>

      <v-progress-linear
        :active="loading"
        :indeterminate="loading"
        absolute
        bottom
        color="#81DBF6"
      ></v-progress-linear>
    </v-toolbar>
    </v-card>

    <v-alert
      class="my-2"
      dense text
      color="#2A353D"
    >
      <v-row no-gutters align="center" class="mx-2">
        <v-col class="py-0">
          <v-select
            @change="getPurchaseSaleMaturities()"
            filled rounded background-color="white" dense clearable
            hide-details
            v-model="parameters.CustodianID"
            :items="allCustodians.filter(a => a.CheckerID != 0 && a.RejectionID == 0)"
            class="mx-1"
            item-text="CustodianName"
            item-value="CustodianID"
            placeholder="----"
            :rules="TextFieldRules"
            label="Custodian"
          ></v-select>
        </v-col>
        <v-col class="py-0">
          <v-select
            @change="getPurchaseSaleMaturities()"
            filled rounded background-color="white" dense clearable
            hide-details
            v-model="parameters.AccountID"
            :items="Accounts.filter(a => a.CheckerID != 0 && a.RejectionID == 0)"
            class="mx-1"
            :item-text="item => item.tblclient.Forename + ` ` + item.tblclient.MajorName +` - ` + item.AccountNumber"
            item-value="AccountID"
            placeholder="----"
            :rules="TextFieldRules"
            label="Account"
          ></v-select>
        </v-col>
        <v-col class="py-0">
          <v-menu
            ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            :return-value.sync="parameters.StartDate"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="parameters.StartDate"
                class="mx-1"
                label="Start Date"
                append-icon="mdi-calendar-month"
                readonly placeholder="--/--/--"
                hide-details
                dense filled rounded background-color="white" color="#2A353D"
                :rules="TextFieldRules"
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker @change="getPurchaseSaleMaturities()" color="#2A353D" v-model="parameters.StartDate" no-title scrollable>
            <v-spacer></v-spacer>
            <v-btn outlined small color="#2A353D" @click="menu = false">Cancel</v-btn>
            <v-btn outlined small color="#2A353D" @click="$refs.menu.save(parameters.StartDate)">OK</v-btn>
            </v-date-picker>
          </v-menu>
        </v-col>
        <v-col class="py-0">
          <v-menu
            ref="menu2"
            v-model="menu2"
            :close-on-content-click="false"
            :return-value.sync="parameters.EndDate"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="parameters.EndDate"
                class="mx-1"
                label="End Date"
                append-icon="mdi-calendar-month"
                readonly placeholder="--/--/--"
                hide-details
                dense filled rounded background-color="white" color="#2A353D"
                :rules="TextFieldRules"
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker @change="getPurchaseSaleMaturities()" color="#2A353D" v-model="parameters.EndDate" no-title scrollable>
            <v-spacer></v-spacer>
            <v-btn outlined small color="#2A353D" @click="menu2 = false">Cancel</v-btn>
            <v-btn outlined small color="#2A353D" @click="$refs.menu2.save(parameters.EndDate)">OK</v-btn>
            </v-date-picker>
          </v-menu>
        </v-col>
      </v-row>
    </v-alert>

    <v-sheet class="mt-4 elevation-12">
      <v-toolbar color="white" dark dense flat>
        <v-spacer/>

        <v-menu open-on-hover offset-y>
          <template v-slot:activator="{ on, attrs }">
          <v-btn v-on="on" v-bind="attrs" outlined small color="#2A353D" class="ml-2">
            EXPORT<v-icon class="ml-1" small>mdi-exit-to-app</v-icon>
          </v-btn>
          </template>
          <v-list dense>
          <v-list-item class="ma-0 pa-0">
            <v-btn @click="generatePDF(false)" text small color="#2A353D">
              <v-icon class="mr-1" small>mdi-file-pdf-box</v-icon>TO PDF
            </v-btn>
          </v-list-item>
          <v-list-item class="ma-0 pa-0">
            <v-btn text small color="#2A353D">
              <download-excel
                :data   = "CurrentPurchaseSaleMaturities"
                type    = "xls"
                name    = "Purchases, Sales and Maturities Report.xls">

                <v-icon class="mr-1" small>mdi-microsoft-excel</v-icon>TO EXCEL
              </download-excel>
            </v-btn>
          </v-list-item>
          <v-list-item class="ma-0 pa-0">
            <v-btn text small color="#2A353D">
              <download-excel
                :data   = "CurrentPurchaseSaleMaturities"
                type    = "csv"
                name    = "Purchases, Sales and Maturities Report.csv">

                <v-icon class="mr-1" small>mdi-file-document-outline</v-icon>TO CSV
              </download-excel>
            </v-btn>
          </v-list-item>
          </v-list>
        </v-menu>
        <v-btn @click="generatePDF(true)" outlined small color="#2A353D" class="ml-2" v-on="on">
          PRINT<v-icon class="ml-1" small>mdi-printer</v-icon>
        </v-btn>

        <template v-slot:extension>
          <v-tabs light color="#2A353D" v-model="tabs" fixed-tabs>
            <v-tabs-slider color="#2A353D"></v-tabs-slider>
            <v-tab>Equity</v-tab>
            <v-tab>Interest Bearing Assets</v-tab>
          </v-tabs>
        </template>
      </v-toolbar>

      <v-tabs-items v-model="tabs">
        <v-tab-item>
          <v-data-table
            :fixed-header="true"
            :headers="equity_headers"
            :items="Equity"
            :search="search"
            :height="390"
            hide-default-footer
            disable-pagination
            @current-items="getFiltered"
          >

            <template v-slot:item.AllocationDate="{ item }">
              {{ item.AllocationDate | moment("YYYY-MM-DD") }}
            </template>

            <template v-slot:item.AllocationRate="{ item }">
              {{Number(item.AllocationRate).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2})}}
            </template>

            <template v-slot:item.DateOpened="{ item }">
              {{ item.DateOpened | moment("DD MMMM YYYY") }}
            </template>
          </v-data-table>
        </v-tab-item>
        <v-tab-item>
          <v-data-table
            :fixed-header="true"
            :headers="interestBearing_headers"
            :items="InterestBearingAssets"
            :search="search"
            :height="390"
            hide-default-footer
            disable-pagination
            @current-items="getFiltered"
          >

            <template v-slot:item.AllocationDate="{ item }">
              {{ item.AllocationDate | moment("YYYY-MM-DD") }}
            </template>

            <template v-slot:item.AllocationRate="{ item }">
              {{Number(item.AllocationRate).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2})}}
            </template>

            <template v-slot:item.DateOpened="{ item }">
              {{ item.DateOpened | moment("DD MMMM YYYY") }}
            </template>
          </v-data-table>          
        </v-tab-item>
      </v-tabs-items>
    </v-sheet>
  </v-container>
</template>

<script>
import reportsService from '../services/reports.service';
import UserService from '../services/user.service';
import {mapGetters} from "vuex";
import jsPDF from 'jspdf';
import 'jspdf-autotable'

export default {
  data () {
    return {
      parameters: {},
      InterestBearingAssets: [],
      Equity: [],
      CurrentPurchaseSaleMaturities: [],
      valid: true,
      filter_dialog: false,
      loading: false,
      search: '',
      message: '',
      menu: false,
      heading: "Purchases, Sales and Maturities",
      menu2: false,
      permitted: null,
      tabs: null,
      permitted_dialog: true,
      interestBearing_headers: [
        {
          text: 'TransactionType',
          align: 'start',
          sortable: false,
          value: 'TransactionType'
        },
        { text: 'ClientName', value: 'ClientName', sortable: false, width: 300 },
        { text: 'Instrument', value: 'Instrument', sortable: false},
        { text: 'Rate', value: 'AllocationRate', sortable: false},
        { text: 'Amount', value: 'AllocationValue', sortable: false},
        { text: 'Date', value: 'AllocationDate', sortable: false, width: 110 },
        { text: 'CounterParty', value: 'CounterPartyName', sortable: false, width: 300 },
        { text: 'MaturityDate', value: 'MaturityDate', sortable: false, width: 110 },
        { text: 'LastCouponDate', value: 'LastCouponDate', sortable: false},
        { text: 'NextCouponDate', value: 'NextCouponDate', sortable: false},
        { text: 'Currency', value: 'Currency', sortable: false},
      ],
      equity_headers: [
        {
          text: 'TransactionType',
          align: 'start',
          sortable: false,
          value: 'TransactionType'
        },
        { text: 'ClientName', value: 'ClientName', sortable: false, width: 300 },
        { text: 'Counter', value: 'Instrument', sortable: false, width: 150},
        { text: 'Quantity', value: 'Quantity', sortable: false},
        { text: 'UnitPrice', value: 'AllocationRate', sortable: false},
        { text: 'Amount', value: 'AllocationValue', sortable: false},
        { text: 'Date', value: 'AllocationDate', sortable: false, width: 110 },
        { text: 'Currency', value: 'Currency', sortable: false},
      ],
    }
  },

  computed: {
    ...mapGetters([
      "currentImage",
      "allCustodians",
      "identity",
      "allCountries",
      "allCities",
      "currentSystemDate",
      "allClientAccounts"
    ]),

    currentUser() {
      return this.$store.state.auth.user;
    },

    Accounts(){
      return this.allClientAccounts.filter(a => a.tblclient.CustodianID == this.parameters.CustodianID)
    },
  },

  created(){
    this.parameters = {
      AccountID: 0,
      CustodianID: 0,
      StartDate: '2021-01-01',
      EndDate: this.currentSystemDate.DayDate
    }
    this.loading = true;
    reportsService.getPurchaseSaleAndMaturities(this.parameters)
    .then(response => {
      this.InterestBearingAssets = response.data.filter(r => r.Asset == 'Money Market' || r.Asset == 'Bond');
      this.Equity = response.data.filter(r => r.Asset == 'Equity');
      this.loading = false
    },
    error => {
    this.message =
      (error.response && error.response.data.message) ||
      error.message ||
      error.toString();
      this.loading = false
    })
  },

  methods: {
    async getPurchaseSaleMaturities() {
      if(this.parameters.AccountID == null || this.parameters.AccountID == ''){
        this.parameters.AccountID = 0
      }
      if(this.parameters.CustodianID == null || this.parameters.CustodianID == ''){
        this.parameters.CustodianID = 0
        this.parameters.AccountID = 0
      }
      if (this.parameters.StartDate != null && this.parameters.EndDate != null) {
        this.loading = true;
        reportsService.getPurchaseSaleAndMaturities(this.parameters)
        .then(response => {
          this.InterestBearingAssets = response.data.filter(r => r.Asset == 'Money Market' || r.Asset == 'Bond');
          this.Equity = response.data.filter(r => r.Asset == 'Equity')
          this.loading = false
        },
        error => {
        this.message =
          (error.response && error.response.data.message) ||
          error.message ||
          error.toString();
          this.loading = false
        })
      }
    },
    generatePDF(IsPrint) {
      const interest_bearing_columns = [
        { title: 'TransactionType',  dataKey: 'TransactionType' },
        { title: 'ClientName', dataKey: 'ClientName' },
        { title: 'Instrument', dataKey: 'Instrument' },
        { title: 'Rate', dataKey: 'AllocationRate' },
        { title: 'Amount', dataKey: 'AllocationValue' },
        { title: 'Date', dataKey: 'AllocationDate', },
        { title: 'CounterParty', dataKey: 'CounterPartyName', },
        { title: 'MaturityDate', dataKey: 'MaturityDate' },
        { title: 'LastCouponDate', dataKey: 'LastCouponDate' },
        { title: 'NextCouponDate', dataKey: 'NextCouponDate' },
        { title: 'Currency', dataKey: 'Currency' },
      ];

      const equity_columns = [
        { title: 'TransactionType',  dataKey: 'TransactionType' },
        { title: 'ClientName', dataKey: 'ClientName' },
        { title: 'Counter', dataKey: 'Instrument' },
        { title: 'Quantity', dataKey: 'Quantity' },
        { title: 'UnitPrice', dataKey: 'AllocationRate' },
        { title: 'Amount', dataKey: 'AllocationValue' },
        { title: 'Date', dataKey: 'AllocationDate', },
        { title: 'Currency', dataKey: 'Currency' },
      ];

      const addFooters = doc => {
        const pageCount = doc.internal.getNumberOfPages()

        for (var i = 1; i <= pageCount; i++) {
          var imgData = 'data:image/png;base64,'+ this.currentImage[0].data;

          doc.addImage(imgData, 'PNG', 0.5, 0.28, 1.3, 0.7);
          doc.setPage(i)
          // text is placed using x, y coordinates
          doc.setFontSize(10).text(this.identity[0].OrgName, 8.5, 0.5);
          doc.setFontSize(6).text(this.identity[0].Phadd1, 8.5, 0.6);
          doc.setFontSize(6).text(this.allCities.filter(a => a.CityID == this.identity[0].PhCity).map(a => a.City)[0], 8.5, 0.7);
          doc.setFontSize(6).text(this.allCountries.filter(a => a.CountryId == this.identity[0].PhCountry).map(a => a.CountryName)[0], 8.5, 0.8);
          doc.setFontSize(6).text('email: ' + this.identity[0].OrgMail, 8.5, 0.9);
          doc.setFontSize(6).text('cell: ' + this.identity[0].OrgNumber, 8.5, 1.0);
          doc.setFontSize(10).text(this.heading, 0.5, 1.2);
          // doc.setFontSize(8).text('Custodian: ' + this.allCustodians.filter(a => a.CustodianID == this.parameters.CustodianID).map(a => a.CustodianName) + '        Client: ' + this.Accounts.filter(a => a.AccountID == this.parameters.AccountID).map(a => a.tblclient.Forename) + ' ' + this.Accounts.filter(a => a.AccountID == this.parameters.AccountID).map(a => a.tblclient.MajorName), 0.5, 1.4);
          // create a line under heading 
          doc.setLineWidth(0.01).line(0.5, 1.7, 10.5, 1.7);
          doc.setLineWidth(0.01).line(0.5, 1.9, 10.5, 1.9);
          doc.setFontSize(6).text('Page ' + String(i) + ' of ' + String(pageCount), 4.3, 10.7, {
            align: 'center'
          })
        }
      }

      let doc = new jsPDF({
        orientation: "landscape",
        unit: "in",
        format: "letter"
      });

      // doc.setFont('helvetica');
      // doc.setFontSize(5);
      // doc.autoTable({
      //   columns,
      //   body: this.CurrentPurchaseSaleMaturities,
      //   margin: { left: 0.5, top: 1.5 },
      //   styles: {overflow: 'linebreak',
      //           fontSize: 6},
      //   showHeader: 'everyPage',
      //   theme: 'plain'
      // });

      doc.setFont('helvetica');
      doc.setFontSize(5);
      if(this.InterestBearingAssets != null && this.InterestBearingAssets != [] && this.InterestBearingAssets != ''){
        doc.autoTable({
          columns: interest_bearing_columns,
          body: this.InterestBearingAssets,
          margin: { left: 0.5, top: 1.7 },
          styles: {overflow: 'linebreak',
                  fontSize: 6},
          showHeader: 'everyPage',
          beforePageContent: function(data) {
            doc.setFontSize(8);
            doc.text("Interest Bearing Assets", 0.5, data.settings.margin.top - 0.1);
          },
          theme: 'plain'
        });
      }
      if(this.Equity != null && this.Equity != [] && this.Equity != ''){
        doc.autoTable({
          startY: (doc.internal.pageSize.getHeight() - doc.autoTableEndPosY()) + doc.autoTableEndPosY(),
          columns: equity_columns,
          body: this.Equity,
          margin: { left: 0.5, top: 1.7 },
          styles: {
            overflow: 'linebreak',
            fontSize: 6
          },
          showHeader: 'everyPage',
          beforePageContent: function(data) {
            doc.setFontSize(8);
            doc.text("Equity", 0.5, data.settings.margin.top - 0.1);
          },
          theme: 'plain'
        });        
      }

      addFooters(doc);
      if(IsPrint == true){
        doc.output('dataurlnewwindow');
      } else{
        doc.save('Purchases, Sales and Maturities Report.pdf')
      }
    },
    getFiltered(current){
      this.CurrentPurchaseSaleMaturities = current;
    },
    showMessage(){
      if(this.message){
        return true
      } else {
        return false
      }
    },
    validate () {
      this.$refs.form.validate()
      return this.valid
    },

    reset () {
      this.$refs.form.reset()
    },
  },

  mounted () {
    UserService.isReports().then(
      () => {
        this.permitted = true;
        this.message = '';
      },
      error => {
        this.permitted = false;
        this.message =
          (error.response && error.response.data.message) ||
          error.message ||
          error.toString();
      }
    );
  }
}
</script>

<style scoped>
.v-btn {
  outline: none
}
</style>